import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../constants/api';
import '../css/modal.css';
import { useTranslation } from 'react-i18next';
import { decodeToken } from '../utils/TokenUtils';
const UpdateModal = ({
  userId,
  token,
  update_link_id,
  table,
  id,
  isOpen,
  onRequestClose,
}) => {
  const { t } = useTranslation();
  const userlevel = decodeToken(token, 'userLevel');

  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [isFile, setIsFile] = useState(false);
  const [queries, setQueries] = useState('');

  const [suggestions, setSuggestions] = useState([]);
  const [message, setMessage] = useState([]);
  //console.log('up tok:',token);
  const [updateValues, setUpdateValues] = useState({
    table: table,
    id: id,
    column: '',
    value: '',
    user_id: userId,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUpdateRecord = `${API_URL}/${ENDPOINTS.SYS}/getupdaterecord/${update_link_id}/${table}/${id}`;
    // console.log('getUpdateRecord:', getUpdateRecord, 'token:', token)
    const fetchForm = async () => {
      const initialState = {};
      const initialButtonState = {};

      try {
        const response = await axios.get(getUpdateRecord, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        //  setLink(response.data.link);
        console.log('getUpdateRecord:', getUpdateRecord);

        console.log('response:', response.data);
        setInputs(response.data);
        //Loop through form inputs and create initial key values form inputs
        if (response.data) {
          response.data.map((input) => {
            if (input.type === 'autocomplete') {
              // setQuery(input.value);
              setQueries((prev) => ({ ...prev, [input.id]: input.value }));
            }
            initialState[input.name] = input.value;
            initialButtonState[input.name] = false;
          });
        }

        //Set all initial input values to the state values
        setValues(initialState);
        setButtons(initialButtonState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();
  }, [table, id]);

  const handleChange = (e, column) => {
    setIsFile(false);

    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setUpdateValues((prevValues) => ({
      ...prevValues,
      value: value,
      column: column,
    }));

    // Show the button when the input field changes
    setButtons({
      ...buttons,
      [name]: value !== '', // Show button if there's any value in the input
    });
  };

  const handleLoadDropdownChange = async (e, input) => {
    const { name, value, type, checked } = e.target;
    const inputId = input.id;
    const inputName = input.name;
    const loadInputName = input.load_input_name;

    //  console.log('input:', input);

    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setUpdateValues((prevValues) => ({
      ...prevValues,
      value: value,
      column: inputName,
    }));

    // Show the button when the input field changes
    setButtons({
      ...buttons,
      [inputName]: value !== '', // Show button if there's any value in the input
    });

    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${inputId}/${value}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      console.log('url:', url, 'response:', response.data);
      //setSuggestions(response.data); // Update suggestions from server response
      console.log('input:', input);
      setInputs((prevInputs) =>
        prevInputs.map(
          (input) =>
            input.name === loadInputName
              ? { ...input, dynamic_options: response.data } // Update the dynamic_options
              : input // Keep other inputs unchanged
        )
      );
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAutocompleteChange = (e, inputId) => {
    const { name, value, type, checked } = e.target;

    setQueries((prev) => ({ ...prev, [inputId]: value }));

    //setInputId(inputId);
    // setQuery(value);

    fetchSuggestions(value, inputId);
  };

  // Function to fetch suggestions from the server
  const fetchSuggestions = async (query, inputId) => {
    if (!query) {
      setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete/${inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      // setSuggestions(response.data); // Update suggestions from server response
      setSuggestions((prev) => ({ ...prev, [inputId]: response.data }));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetClickedValue = (input, suggestion) => {
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [input.name]: suggestion.id,
    }));
    // setQuery(suggestion.name);

    setQueries((prev) => ({ ...prev, [input.id]: suggestion.name }));
    setSuggestions((prev) => ({ ...prev, [input.id]: [] }));
  };

  // Handle file input changes dynamically
  const handleFileChange = (e, column) => {
    setIsFile(true);

    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));

    setUpdateValues((prevValues) => ({
      ...prevValues,
      value: file,
      column: column,
    }));

    // Show the button when the input field changes
    setButtons({
      ...buttons,
      [name]: file !== '', // Show button if there's any value in the input
    });
  };

  const handleMultiFileChange = (e, column) => {
    setIsFile(true);

    const { name } = e.target;
    const files = Array.from(e.target.files); // Convert FileList to array

    setValues((prev) => ({
      ...prev,
      [name]: files, // Store array of files for the input field
    }));

    setUpdateValues((prevValues) => ({
      ...prevValues,
      value: files,
      column: column,
    }));

    // Show the button when the input field changes
    setButtons({
      ...buttons,
      [name]: files !== '', // Show button if there's any value in the input
    });
  };

  //console.log('isFile: ', isFile);
  //console.log('insert route:', `${API_URL}/${ENDPOINTS.SYS}/create/${route}`)
  // console.log('updateValues:', updateValues);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const description = prompt('Please enter a description for updating:');

      // If user cancels or enters nothing, stop the submission
      if (!description) {
        alert('Update canceled. Description is required.');
        return;
      }
      var updateUrl = `${API_URL}/${ENDPOINTS.SYS}/updatecolumn`;

      if (isFile) {
        updateUrl = `${API_URL}/${ENDPOINTS.SYS}/updatefile/${updateValues.table}/${updateValues.column}`;
        //console.log('insert route:',insertUrl)
        const data = new FormData();

        // Append all fields (including files) to FormData
        // Object.keys(updateValues).forEach((key) => {
        //   data.append(key, updateValues[key]); // Appends both files and text fields dynamically
        // });

        Object.keys(updateValues).forEach((key) => {
          const value = updateValues[key];

          if (Array.isArray(value)) {
            value.forEach((file) => {
              data.append(key, file); // ✅ No square brackets
            });
          } else {
            data.append(key, value);
          }
        });

        data.append('description', description);

        //console.log('data:', data, ' data2:', data);
        const response = await axios.post(updateUrl, data, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'multipart/form-data', //required for upload
          },
        });
        // console.log('response:', response.data);
        // console.log('data:', data.entries());

        // print console url, request and response

        if (userlevel === 'developer') {
          console.log(
            'url:',
            updateUrl,
            'request:',
            data,
            'reponse:',
            response.data
          );
        }

        setMessage(response.data);

        // onRequestClose(); // Close modal after submission
        if (response.data.success === 0) {
          notification.error({ message: response.data.message });
        } else {
          notification.success({ message: response.data.message });
        }
      } else {
        const dataWithDescription = {
          ...updateValues, // Replace with your actual data
          description: description,
        };
        console.log('data:', updateValues, ' data2:', dataWithDescription);

        const response = await axios.put(updateUrl, dataWithDescription, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        console.log('response:', response);

        setMessage(response.data);

        // onRequestClose(); // Close modal after submission
        if (response.data.success === 0) {
          notification.error({ message: response.data.message });
        } else {
          notification.success({ message: response.data.message });
        }
      }

      // Show the button when the input field changes
      setButtons({
        ...buttons,
        [updateValues.column]: '', // Show button if there's any value in the input
      });
    } catch (error) {
      notification.error({ message: error.message });
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Update</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body  ">
            {inputs.map((input) => {
              const options =
                input.options?.split(',').map((option) => option.trim()) || [];

              return (
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="row">
                    <div className="col-9" key={input.name}>
                      {input.type !== 'hidden-user' &&
                        input.type !== 'hidden-branch' &&
                        input.type !== 'hidden' && (
                          <>
                            <label
                              htmlFor={input.name}
                              className="form-label text-capitalize font-weight-bold"
                            >
                              {/* {input.label}:{' '} */}
                              {t(input.label)}:{' '}
                              {input.is_required === 'required' && (
                                <span
                                  className="text-danger"
                                  title={`'${input.label}' field is required, please fill it before submit the form`}
                                >
                                  {' '}
                                  *
                                </span>
                              )}
                            </label>{' '}
                            &nbsp;&nbsp;
                          </>
                        )}
                      {(() => {
                        switch (input.type) {
                          case 'radio':
                            return (
                              input.dynamic_options &&
                              input.dynamic_options.map((option, index) => (
                                <div
                                  className="form-check form-check-inline"
                                  key={index}
                                >
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id={`${input.name}-${index}`}
                                    name={input.name}
                                    value={option.id}
                                    checked={values[input.name] === option.id}
                                    onChange={(e) =>
                                      handleChange(e, input.name)
                                    }
                                  />
                                  <label
                                    htmlFor={`${input.name}-${index}`}
                                    className="form-check-label"
                                  >
                                    {option.name}
                                  </label>
                                </div>
                              ))
                            );

                          case 'dropdown':
                            return (
                              <select
                                className="form-select"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                              >
                                <option value="">Select an option</option>

                                {input.dynamic_options &&
                                  (() => {
                                    // check if any option has a 'group' key
                                    const hasGroup = input.dynamic_options.some(
                                      (opt) => opt.group
                                    );

                                    if (hasGroup) {
                                      // group options by 'group' key
                                      const grouped =
                                        input.dynamic_options.reduce(
                                          (acc, opt) => {
                                            const groupName =
                                              opt.group || 'Ungrouped';
                                            if (!acc[groupName])
                                              acc[groupName] = [];
                                            acc[groupName].push(opt);
                                            return acc;
                                          },
                                          {}
                                        );

                                      return Object.entries(grouped).map(
                                        ([group, options]) => (
                                          <optgroup key={group} label={group}>
                                            {options.map((opt) => (
                                              <option
                                                key={opt.id}
                                                value={opt.id}
                                              >
                                                {opt.name}
                                              </option>
                                            ))}
                                          </optgroup>
                                        )
                                      );
                                    } else {
                                      // normal options
                                          return input.dynamic_options.map(
                                          (opt) => {
                                            const optionKeys = Object.keys(opt);

                                        // Access the first and second key values (fallback to default if less than 2 keys exist)
                                        const firstValue =
                                          opt[optionKeys[0]] || 'No Value 1';
                                        const secondValue =
                                          opt[optionKeys[1]] || 'No Value 2';
                                            return <option key={firstValue} value={firstValue}>
                                              {secondValue}
                                            </option>
                                          }
                                        );


                                    }
                                  })()}
                              </select>

                              // <select
                              //   className="form-select"
                              //   id={input.name}
                              //   name={input.name}
                              //   value={values[input.name]}
                              //   onChange={(e) => handleChange(e, input.name)}
                              //   required={input.is_required}
                              // >
                              //   <option value="" disabled>
                              //     Select an option
                              //   </option>
                              //   {input.dynamic_options &&
                              //     input.dynamic_options.map((option, index) => (
                              //       <option key={index} value={option.id}>
                              //         {option.name}
                              //       </option>
                              //     ))}
                              // </select>
                            );
                          case 'group-dropdown':
                            return (
                              <select
                                className="form-select"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                              >
                                <option value="" disabled>
                                  Select an option
                                </option>
                                {input.dynamic_options &&
                                  Object.entries(
                                    input.dynamic_options.reduce(
                                      (groups, option) => {
                                        // Group options by the 'group' key
                                        if (!groups[option.group])
                                          groups[option.group] = [];
                                        groups[option.group].push(option);
                                        return groups;
                                      },
                                      {}
                                    )
                                  ).map(([group, options]) => (
                                    <optgroup key={group} label={group}>
                                      {options.map((option) => (
                                        <option
                                          key={option.id}
                                          value={option.id}
                                        >
                                          {option.name}
                                        </option>
                                      ))}
                                    </optgroup>
                                  ))}
                              </select>
                            );

                          case 'load-dropdown':
                            return (
                              <select
                                className="form-select"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={(e) =>
                                  handleLoadDropdownChange(e, input)
                                }
                                required={input.is_required}
                              >
                                <option value="%">Select all</option>
                                {input.dynamic_options?.map((option, index) => (
                                  <option key={index} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            );

                          case 'autocomplete':
                            return (
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control" // Bootstrap class for styling
                                  value={queries[input.id] || ''}
                                  onChange={(e) =>
                                    handleAutocompleteChange(e, input.id)
                                  }
                                  placeholder="Search..."
                                  style={{
                                    width: '100%', // Ensure it matches the container width
                                  }}
                                />
                                {loading && <div>Loading...</div>}
                                {suggestions[input.id]?.length > 0 && (
                                  <ul
                                    className="list-group position-absolute"
                                    style={{
                                      margin: 0,
                                      top: '100%',
                                      width: '100%',
                                      zIndex: 1,
                                      maxHeight: '200px', // Limit height
                                      overflowY: 'auto', // Add vertical scroll
                                      border: '1px solid #ccc', // Add border for better visibility
                                      borderRadius: '4px',
                                      backgroundColor: '#fff',
                                    }}
                                  >
                                    {suggestions[input.id].map(
                                      (suggestion, index) => (
                                        <li
                                          className="list-group-item"
                                          key={index}
                                          onClick={() => {
                                            handleSetClickedValue(
                                              input,
                                              suggestion
                                            ); // Set clicked suggestion as the query
                                            //   setSuggestions([]); // Clear suggestions after selection
                                          }}
                                          style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                          }}
                                        >
                                          {suggestion.name}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                              </div>
                            );

                          case 'enum':
                            return (
                              options &&
                              options.map((option, index) => (
                                <div
                                  className="form-check form-check-inline"
                                  key={index}
                                >
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id={`${input.name}-${index}`}
                                    name={input.name}
                                    value={option}
                                    checked={values[input.name] === option}
                                    onChange={(e) =>
                                      handleChange(e, input.name)
                                    }
                                  />
                                  <label
                                    htmlFor={`${input.name}-${index}`}
                                    className="form-check-label"
                                  >
                                    {option}
                                  </label>
                                </div>
                              ))
                            );
                          case 'enum-dropdown':
                            return (
                              <select
                                className="form-select"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                              >
                                <option value="" disabled>
                                  Select an option
                                </option>
                                {options &&
                                  options.map((option, index) => (
                                    <option key={index} value={option}>
                                      {option}
                                    </option>
                                  ))}
                              </select>
                            );

                          case 'checkbox':
                            return (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  checked={values[input.name]}
                                  onChange={handleChange}
                                />
                                <label
                                  htmlFor={input.name}
                                  className="form-check-label"
                                >
                                  {input.label}
                                </label>
                              </div>
                            );

                          case 'hidden-user':
                            return (
                              <input
                                type="hidden"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={handleChange}
                                required={input.is_required}
                              />
                            );
                          case 'hidden-branch':
                            return (
                              <input
                                type="hidden"
                                id={input.name}
                                name={input.name}
                                value={values[input.name]}
                                onChange={handleChange}
                                required={input.is_required}
                              />
                            );

                          case 'textarea':
                            return (
                              <textarea
                                className="form-control"
                                id={input.name}
                                name={input.name}
                                rows="3"
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                              ></textarea>
                            );
                          case 'file':
                            return (
                              <>
                                <input
                                  title="file"
                                  type={input.type}
                                  className="form-control"
                                  id={input.name}
                                  name={input.name}
                                  placeholder={input.placeholder}
                                  onChange={(e) =>
                                    handleFileChange(e, input.name)
                                  }
                                  required={input.is_required}
                                  accept={input.allowed_extensions} // Restricts file type selection in the browser
                                />
                                <p className="text-danger">
                                  Only allowed files: '
                                  {input.allowed_extensions}', Max size:{' '}
                                  {input.max_size_mb}MB
                                </p>
                              </>
                            );
                          case 'multi-file':
                            return (
                              <>
                                <input
                                  title="file"
                                  type={'file'}
                                  multiple
                                  className="form-control"
                                  id={input.name}
                                  name={input.name}
                                  placeholder={input.placeholder}
                                  onChange={(e) =>
                                    handleMultiFileChange(e, input.name)
                                  }
                                  required={input.is_required}
                                  accept={input.allowed_extensions} // Restricts file type selection in the browser
                                />
                                <p className="text-danger">
                                  Only allowed files: '
                                  {input.allowed_extensions}', Max size:{' '}
                                  {input.max_size_mb}MB
                                </p>
                              </>
                            );

                          case 'today-date':
                            return (
                              <input
                                type={input.type}
                                className="form-control"
                                id={input.name}
                                name={input.name}
                                placeholder={input.placeholder}
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                                readOnly
                              />
                            );
                          default:
                            return (
                              <input
                                type={input.type}
                                className="form-control"
                                id={input.name}
                                name={input.name}
                                placeholder={input.placeholder}
                                value={values[input.name]}
                                onChange={(e) => handleChange(e, input.name)}
                                required={input.is_required}
                              />
                            );
                        }
                      })()}
                    </div>
                    <div className="col-2">
                      {buttons[input.name] && (
                        <>
                          <label
                            htmlFor={input.name}
                            className="form-label text-capitalize font-weight-bold"
                          >
                            &nbsp;
                          </label>{' '}
                          &nbsp;&nbsp;
                          <button type="submit" className="btn btn-primary">
                            Update
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </form>
              );
            })}

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateModal;
